import React from "react";
import useCurrency from "../../../../../hooks/useCurrency";

import {

    Card,
    Statistic,
    Tag

} from "antd";

const CounterOfferCard = ({ counterOffer }) => {

    const { symbol } = useCurrency();

    return (

        <Card

            style={{

                borderRadius:12,

                border:"1px solid orange",

                marginBottom:18

            }}

        >

            <Tag color="orange">

                Contre-proposition

            </Tag>

            <Statistic

                title="Prix demandé"

                value={counterOffer.price}

                suffix={symbol(counterOffer.currency)}

            />

            <Statistic

                title="Quantité"

                value={counterOffer.quantity}

                suffix="Kg"

            />

        </Card>

    );

};

export default CounterOfferCard;